import { subscribeToEvent } from '../tools/event-subscribe';

export function pressingDownDurationCollector(onData) {
  const data = [];
  let startTime = null;
  let startX,
    startY;
  let pressDownSubscriptions = [];

  /**
     *
     * @param {MouseEvent | TouchEvent} e
     */
  function handlePressDown(e) {
    const coords = getClientCoords(e, true);
    if (coords) {
      startX = coords.clientX;
      startY = coords.clientYl;
    } else {
      // more than 1 touch
      return;
    }

    startTime = e.timeStamp;

    pressDownSubscriptions = [
      subscribeToEvent(window, 'mousemove', handlePressMove, { capture: true }),
      subscribeToEvent(window, 'touchmove', handlePressMove, { capture: true }),
      subscribeToEvent(window, 'mouseup', handlePressUp, { capture: true }),
      subscribeToEvent(window, 'touchend', handlePressUp, { capture: true }),
    ];
  }

  /**
     *
     * @param {MouseEvent | TouchEvent} e
     */
  function handlePressMove(e) {
    const { clientX, clientY } = getClientCoords(e, false);

    const moveX = Math.abs(clientX - startX);
    const moveY = Math.abs(clientY - startY);

    if (moveX > 0 || moveY > 0) {
      stopTrackTime(e);
    }
  }

  /**
     *
     * @param {MouseEvent | TouchEvent} e
     * @param {boolean} single
     */
  function getClientCoords(e, single) {
    if (e instanceof MouseEvent) {
      const { clientX, clientY } = e;
      return { clientX, clientY };
    } else if (!single || e.touches.length === 1) {
      const { clientX, clientY } = e.touches[0];
      return { clientX, clientY };
    }
    return null;
  }

  /**
     *
     * @param {Event} e
     */
  function handlePressUp(e) {
    stopTrackTime(e);
  }

  /**
     *
     * @param {Event} e
     */
  function stopTrackTime(e) {
    pressDownSubscriptions.forEach(u => u());
    pressDownSubscriptions = [];

    const time = e.timeStamp - startTime;
    data.push(time);
    onData({ mouseDownTime: time });
  }

  const subscriptions = [
    subscribeToEvent(window, 'mousedown', handlePressDown, { capture: true }),
    subscribeToEvent(window, 'touchstart', handlePressDown, { capture: true }),
  ];

  function stop() {
    subscriptions.forEach(u => u());
  }

  function toString() {
    if (data.length) {
      const s = data.reduce((p, c) => p + c);
      return Math.round(s / data.length).toString();
    }
    return '';
  }

  return {
    data,
    toString,
    stop,
  };
}



// WEBPACK FOOTER //
// ./src/lib/collectors/pressing-down-duration.js